import * as types from '../actions/types';

export const initialState = {
  version: 0,
  addressesVersion: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_COMPANIES_VERSION:
      return {
        ...state,
        version: state.version + 1
      };
    case types.CHANGE_COMPANY_ADDRESSES_VERSION:
      return {
        ...state,
        addressesVersion: state.addressesVersion + 1
      };
    default:
      return state;
  }
};
